import { createEffect, createStore } from 'effector';

import {
  categoriesApi,
  projectsApi,
  currenciesApi,
  customFieldsApi,
} from '../api';
import {
  $currentWorkspaceId,
  workspaceChanged,
  sessionCleared,
} from './session';

/**
 * The current workspace's lookup lists, shared by every RecordFlow page.
 * Call an effect after changing its list to refresh it everywhere.
 */
function createReferenceList(name, resource) {
  const fetchFx = createEffect(`fetch recordflow ${name}`);
  fetchFx.use(() => resource.list($currentWorkspaceId.getState()));

  const $list = createStore([])
    .on(fetchFx.done, (_, { result }) => result)
    .reset(workspaceChanged, sessionCleared);

  return [$list, fetchFx];
}

export const [$categories, fetchCategoriesFx] = createReferenceList(
  'categories',
  categoriesApi,
);
export const [$projects, fetchProjectsFx] = createReferenceList(
  'projects',
  projectsApi,
);
export const [$currencies, fetchCurrenciesFx] = createReferenceList(
  'currencies',
  currenciesApi,
);
export const [$customFields, fetchCustomFieldsFx] = createReferenceList(
  'custom fields',
  customFieldsApi,
);

export const loadReferenceDataFx = createEffect(
  'load recordflow reference data',
);
loadReferenceDataFx.use(() =>
  Promise.all([
    fetchCategoriesFx(),
    fetchProjectsFx(),
    fetchCurrenciesFx(),
    fetchCustomFieldsFx(),
  ]),
);

/** Currency code for a currency id, falling back to the record's own code. */
export function currencyCode(currencies, currencyId, fallback = 'USD') {
  const currency = currencies.find(item => item.id === currencyId);
  return currency ? currency.code : fallback;
}
